export default __webpack_public_path__ + "static/bg-girl-thermometer-10114f0f0858379eb97fc761127e4d66.jpg";